import {Injectable} from "@angular/core";

@Injectable()
export class CompareValueService {
    constructor() {
    }

    sortValue(a: any, b: any) {
        if (a < b) {
            return -1;
        }
        if (a > b) {
            return 1;
        }
        return 0;
    }


}